import {
  MediaCardContainer,
  MediaContainer,
  ViewContainer,
} from "./Media.styled";
import { GalleryData } from "../../components/mediaGallery";
import pic from "../../assets/pic.svg";
import vid from "../../assets/vid.svg";
import { useState } from "react";
import { Backdrop } from "@mui/material";

const Media = () => {
  const [open, setOpen] = useState(false);
  const [galId, setGalId] = useState<number>(0);
  const handleClose = () => {
    setOpen(false);
  };
  const viewHandler = (id: any) => {
    setGalId(id);
    console.log(id);
    setOpen(true);
  };
  return (
    <>
      <MediaContainer>
        {GalleryData.map((media, index) => (
          <MediaCardContainer onClick={() => viewHandler(index)}>
            <div key={index}>
              {media.type === "vid" ? (
                <iframe
                  src={media.src}
                  height={"420px"}
                  width={"100%"}
                  frameBorder={"none"}
                  title="unique"
                ></iframe>
              ) : (
                <img src={media.src} alt={media.type} />
              )}
            </div>
            <section>
              <section style={{ display: "flex", alignItems: "center" }}>
                <p>{media.date}</p>
                {media.type === "vid" ? (
                  <img src={vid} alt="" />
                ) : (
                  <img src={pic} alt="" />
                )}
              </section>
              <section>
                <span>{media.data}</span>
              </section>
            </section>
          </MediaCardContainer>
        ))}
      </MediaContainer>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <ViewContainer>
          <>
            {GalleryData[galId].type === "vid" ? (
              <iframe
                src={GalleryData[galId].src}
                title={GalleryData[galId].date}
                frameBorder="none"
                height={"420px"}
                width={"100%"}
              ></iframe>
            ) : (
              <img src={GalleryData[galId].src} alt="" />
            )}
            <section>
              <p>{GalleryData[galId].data}</p>
            </section>
          </>
        </ViewContainer>
      </Backdrop>
    </>
  );
};

export default Media;
